/**
 * Users service
 */

import Resource from './resource'

export default new Resource('users')



// WEBPACK FOOTER //
// ./src/libraries/services/users.js